import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import axios from "axios";
import { handleAxiosError } from "./servicesUtils";
var baseStatisticControllerUrl = "/rest/statistics";
export var updateViewListing = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    yield axios.post("".concat(baseStatisticControllerUrl, "/updateViewListing/W"), data);
    return true;
  } catch (error) {
    handleAxiosError(error);
    return false;
  }
});
export var updateRealEstateSearch = realEstateSearchBean => __awaiter(void 0, void 0, void 0, function* () {
  try {
    yield axios.post("".concat(baseStatisticControllerUrl, "/updateRealEstateSearch"), realEstateSearchBean);
    return true;
  } catch (error) {
    handleAxiosError(error);
    return false;
  }
});
export var updatePhoneView = (agencyId, id) => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post(id ? "".concat(baseStatisticControllerUrl, "/updatePhoneView/").concat(agencyId, "/").concat(id, "/W") : "/rest/statistics/updatePhoneView/".concat(agencyId, "/W"));
    return res.data;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
});
export var getPlaceTrendData = place => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var promiseSale = yield axios.post("".concat(baseStatisticControllerUrl, "/getPlaceTrendData?sale=", true), place);
    var promiseRent = yield axios.post("".concat(baseStatisticControllerUrl, "/getPlaceTrendData?sale=", false), place);
    return Promise.all([promiseSale, promiseRent]);
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
});
export var getSaleGraphData = function getSaleGraphData(place) {
  var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    contract: "sale",
    macroTypologyId: 1
  };
  return __awaiter(void 0, void 0, void 0, function* () {
    try {
      var res = yield axios.post("".concat(baseStatisticControllerUrl, "/getAveragePriceGraphData/").concat(filters.contract, "/").concat(filters.macroTypologyId), place);
      return res.data;
    } catch (error) {
      handleAxiosError(error);
      throw error;
    }
  });
};
export var updateViewDetail = data => __awaiter(void 0, void 0, void 0, function* () {
  try {
    var res = yield axios.post("".concat(baseStatisticControllerUrl, "/updateViewDetail/W"), data);
    return res.data;
  } catch (e) {
    handleAxiosError(e);
    throw e;
  }
});